function setBundleImage() {
  const dotBundleJSON = document.querySelector(
    '#dot-bundle-product[type="application/json"]'
  );
  const firstItemElement = document.querySelector(
    '#cart-item-1[type="application/json"]'
  );
  const blackBundleRender = document.getElementById("BlackBundleRender");
  const blueBundleRender = document.getElementById("BlueBundleRender");
  const whiteBundleRender = document.getElementById("WhiteBundleRender");
  const yellowBundleRender = document.getElementById("YellowBundleRender");
  const greenBundleRender = document.getElementById("GreenBundleRender");
  const mintBundleRender = document.getElementById("MintBundleRender");
  const redBundleRender = document.getElementById("RedBundleRender");
  const purpleBundleRender = document.getElementById("PurpleBundleRender");
  const blackBundleRenderClassic = document.getElementById("BlackBundleRenderClassic");
  const blueBundleRenderClassic = document.getElementById("BlueBundleRenderClassic");
  const whiteBundleRenderClassic = document.getElementById("WhiteBundleRenderClassic");
  const yellowBundleRenderClassic = document.getElementById("YellowBundleRenderClassic");
  const greenBundleRenderClassic = document.getElementById("GreenBundleRenderClassic");
  const mintBundleRenderClassic = document.getElementById("MintBundleRenderClassic");
  const redBundleRenderClassic = document.getElementById("RedBundleRenderClassic");
  const purpleBundleRenderClassic = document.getElementById("PurpleBundleRenderClassic");
  let dotBundleVariants;
  let firstItem;
  let dotBundleData;
  if (dotBundleJSON) {
    dotBundleData = JSON.parse(dotBundleJSON.textContent)[0];
    dotBundleVariants = dotBundleData.variants;
  }
  if (firstItemElement) {
    firstItem = JSON.parse(firstItemElement.textContent);
  }
  const getBundleRender = (color) => {
    switch (color) {
      case "black":
        return blackBundleRender.src;
      case "blue":
        return blueBundleRender.src;
      case "white":
        return whiteBundleRender.src;
      case "yellow":
        return yellowBundleRender.src;
      case "green":
        return greenBundleRender.src;
      case "mint":
        return mintBundleRender.src;
      case "red":
        return redBundleRender.src;
      case "purple":
        return purpleBundleRender.src;
      case "black-classic":
        return blackBundleRenderClassic.src;
      case "blue-classic":
        return blueBundleRenderClassic.src;
      case "white-classic":
        return whiteBundleRenderClassic.src;
      case "yellow-classic":
        return yellowBundleRenderClassic.src;
      case "green-classic":
        return greenBundleRenderClassic.src;
      case "mint-classic":
        return mintBundleRenderClassic.src;
      case "red-classic":
        return redBundleRenderClassic.src;
      case "purple-classic":
        return purpleBundleRenderClassic.src;
      default:
        null;
    }
  };
  if (
    firstItem?.product_type.toLowerCase().includes("card") ||
    firstItem?.product_type.toLowerCase().includes("thin") ||
    firstItem?.product_type.toLowerCase().includes("classic") ||
    firstItem?.product_type.toLowerCase().includes("band")
  ) {
    const isClassic = firstItem?.product_type.toLowerCase().includes("classic");
    
    // Find the bundle variant that matches the color
    let dotBundle = null;
    if (isClassic) {
      dotBundle = dotBundleVariants.find(
        (variant) =>
          variant.option1.toLowerCase() ===
          firstItem.variant_options[0].toLowerCase() && variant.option2.toLowerCase() === 'classic'
      );
    } else {
      dotBundle = dotBundleVariants.find(
        (variant) =>
          variant.option1.toLowerCase() ===
          firstItem.variant_options[0].toLowerCase()
      );
    }
    
    if (dotBundle) {
      let bundleImage = '';
      if (isClassic) {
        bundleImage = firstItem.variant_options[0].toLowerCase() + "-classic";
      } else if (firstItem.variant_options[0]) {
        bundleImage = firstItem.variant_options[0].toLowerCase();
      }
      const image =
        getBundleRender(bundleImage) ||
        dotBundle.featured_image.src;
      // Set bundle image

      document
        .querySelectorAll(".special-offer__image")
        .forEach((el) => (el.src = image));
      document
        .querySelectorAll(".special-offer a")
        .forEach(
          (el) =>
            (el.href = `/products/${dotBundleData.handle}?variant=${dotBundle.id}`)
        );
    }
  }
}

setBundleImage();
